import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { setThemeMode, getThemeMode } from "@/context/ThemeProvider";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AdminConsole from "@/pages/AdminConsole";
import OperatorLayout from "@/pages/OperatorLayout";
import LiveBoard from "@/pages/LiveBoard";
import Dashboard from "@/pages/Dashboard";
import RentalsPipeline from "@/pages/RentalsPipeline";
import RecoveryBoard from "@/pages/RecoveryBoard";
import Maintenance from "@/pages/Maintenance";
import MechanicApp from "@/pages/MechanicApp";
import TouristBookings from "@/pages/TouristBookings";
import BusinessFleet from "@/pages/BusinessFleet";
import PublicBooking from "@/pages/PublicBooking";
import OperatorBilling from "@/pages/OperatorBilling";
import OperatorAnalytics from "@/pages/OperatorAnalytics";
import VehicleHistory from "@/pages/VehicleHistory";
import OperatorDelivery from "@/pages/OperatorDelivery";
import RiderCheckin from "@/pages/RiderCheckin";
import RiderPortal from "@/pages/RiderPortal";
import FleetOSLanding from "@/pages/FleetOSLanding";
import OperatorLanding from "@/pages/OperatorLanding";
import SettingsPage from "@/pages/SettingsPage";
import DiscoveryForm from "@/pages/DiscoveryForm";
import DiscoveryInsights from "@/pages/DiscoveryInsights";
import { Toaster } from "@/components/ui/sonner";

const OPERATOR_ROLES = ["owner", "counter_staff", "rider", "tourist"];

function App() {
  useEffect(() => { setThemeMode(getThemeMode()); }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<FleetOSLanding />} />
          <Route path="/o/:subdomain" element={<OperatorLanding />} />
          <Route path="/login" element={<Login />} />
          <Route path="/book/:subdomain" element={<PublicBooking />} />
          <Route path="/r/:qrToken" element={<RiderCheckin />} />
          <Route path="/rider" element={<RiderPortal />} />
          <Route path="/discovery" element={<DiscoveryForm />} />
          <Route path="/discovery/insights" element={<DiscoveryInsights />} />
          <Route path="/admin" element={
            <ProtectedRoute roles={["super_admin"]}><AdminConsole /></ProtectedRoute>
          } />
          <Route path="/mechanic" element={
            <ProtectedRoute roles={["mechanic"]}><MechanicApp /></ProtectedRoute>
          } />
          <Route path="/app" element={
            <ProtectedRoute roles={OPERATOR_ROLES}><OperatorLayout /></ProtectedRoute>
          }>
            <Route index element={<LiveBoard />} />
            <Route path="fleet" element={<Dashboard />} />
            <Route path="rentals" element={<RentalsPipeline />} />
            <Route path="recovery" element={<RecoveryBoard />} />
            <Route path="maintenance" element={<Maintenance />} />
            <Route path="tourist-bookings" element={<TouristBookings />} />
            <Route path="business" element={<BusinessFleet />} />
            <Route path="delivery" element={<OperatorDelivery />} />
            <Route path="billing" element={<OperatorBilling />} />
            <Route path="analytics" element={<OperatorAnalytics />} />
            <Route path="vehicle/:id/history" element={<VehicleHistory />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
